import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {ScreenName, Screens} from './Screens';
import HeaderBackButton from 'components/atoms/headerBackButton';
import strings from '../translations';
import {Platform} from 'react-native';
import styleSheet from './styles';

const Stack = createNativeStackNavigator();

export interface AnalyticsScreenProps {
  route: any;
  navigation: NativeStackNavigationProp<{
    [ScreenName.analyticInfo]: {
      id: string;
      title: string;
      classMarking: string;
      classDate: string;
      isRecordingNeeded: boolean;
    };
    [ScreenName.charts]: {
      id: string;
      title: string;
      classMarking: string;
      classDate: string;
    };
    [ScreenName.attendees]: {
      id: string;
    };
    [ScreenName.transcriptions]: {
      id: string;
      title: string;
      classMarking: string;
      classDate: string;
    };
  }>;
}

const AnalyticsFlow = () => {
  const theme = useTheme();
  const styles = styleSheet(useTheme());

  return (
    <Stack.Navigator
      screenOptions={({navigation, route}) => ({
        headerLeft: () => <HeaderBackButton onPress={() => navigation.pop()} />,
        headerStyle: styles.headerStyle,
        headerTitleStyle: styles.headerTitleStyle,
        headerTitleAlign: 'center',
        headerShadowVisible: false,
      })}>
      <Stack.Screen
        name={Screens.AnalyticsScreen.name}
        component={Screens.AnalyticsScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.AnalyticInfoScreen.name}
        component={Screens.AnalyticInfoScreen.screen}
        options={{
          title: strings.analyticsScreen.analytics,
          headerShown: Platform.OS !== 'web',
        }}
      />
      <Stack.Screen
        name={Screens.ChartsScreen.name}
        component={Screens.ChartsScreen.screen}
        options={{
          headerShown: false,
          orientation: 'landscape',
        }}
      />
      <Stack.Screen
        name={Screens.TranscriptionsScreen.name}
        component={Screens.TranscriptionsScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.AttendeesScreen.name}
        component={Screens.AttendeesScreen.screen}
        options={{
          title: strings.analyticsScreen.attendees,
          headerShown: Platform.OS !== 'web',
        }}
      />
    </Stack.Navigator>
  );
};

export default AnalyticsFlow;
